{
  "title": "網路電話",
  "call": "撥打電話",
  "hangup": "掛斷電話",
  "idle": "可撥號",
  "dialing": "撥號中...",
  "ringing": "正在呼叫...",
  "established": "通話中",
  "terminated": "通話結束",
  "ended": "通話已結束",
  "error": {
    "credential": "驗證失敗，請稍後再試",
    "connection": "連線被拒或無法連線 (驗證未通過)",
    "rejected": "撥號失敗 (對方無回應或被拒)",
    "media": "通話媒體中斷 (網路/中繼問題)",
    "micDenied": "請允許使用麥克風後再撥號;若您在 App(如 LINE)的內建瀏覽器中,請改用 Chrome 或 Safari 開啟本頁。",
    "micUnsupported": "此瀏覽器不支援麥克風存取,請改用 Chrome / Safari 等較新的瀏覽器。",
    "micNotFound": "找不到麥克風裝置,請確認麥克風已連接後再試。",
    "micHardware": "無法使用麥克風(可能被其他程式占用),請關閉佔用的程式後再試。",
    "micInsecure": "請以 https 安全連線開啟本頁,瀏覽器才允許使用麥克風。",
    "audioPlayBlocked": "瀏覽器阻擋了自動播放,請點一下畫面以開啟通話聲音。",
    "connectionLost": "連線中斷，系統將自動重連，請稍候…"
  }
}